/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.DataContent', null, global);
goog.exportSymbol('proto.DataContent.ChatMsgContent', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.DataContent.displayName = 'proto.DataContent';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataContent.prototype.toObject = function(opt_includeInstance) {
  return proto.DataContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    action: jspb.Message.getFieldWithDefault(msg, 1, 0),
    chatmsgcontent: (f = msg.getChatmsgcontent()) && proto.DataContent.ChatMsgContent.toObject(includeInstance, f),
    extend: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataContent}
 */
proto.DataContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataContent;
  return proto.DataContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataContent}
 */
proto.DataContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAction(value);
      break;
    case 2:
      var value = new proto.DataContent.ChatMsgContent;
      reader.readMessage(value,proto.DataContent.ChatMsgContent.deserializeBinaryFromReader);
      msg.setChatmsgcontent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExtend(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAction();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getChatmsgcontent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.DataContent.ChatMsgContent.serializeBinaryToWriter
    );
  }
  f = message.getExtend();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.DataContent.ChatMsgContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.DataContent.ChatMsgContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.DataContent.ChatMsgContent.displayName = 'proto.DataContent.ChatMsgContent';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.DataContent.ChatMsgContent.prototype.toObject = function(opt_includeInstance) {
  return proto.DataContent.ChatMsgContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DataContent.ChatMsgContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataContent.ChatMsgContent.toObject = function(includeInstance, msg) {
  var f, obj = {
    userid: jspb.Message.getFieldWithDefault(msg, 1, ""),
    talkid: jspb.Message.getFieldWithDefault(msg, 2, ""),
    msgcontent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    signflag: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DataContent.ChatMsgContent}
 */
proto.DataContent.ChatMsgContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.DataContent.ChatMsgContent;
  return proto.DataContent.ChatMsgContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DataContent.ChatMsgContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DataContent.ChatMsgContent}
 */
proto.DataContent.ChatMsgContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTalkid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsgcontent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSignflag(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.DataContent.ChatMsgContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.DataContent.ChatMsgContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DataContent.ChatMsgContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.DataContent.ChatMsgContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTalkid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMsgcontent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSignflag();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string userId = 1;
 * @return {string}
 */
proto.DataContent.ChatMsgContent.prototype.getUserid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.DataContent.ChatMsgContent.prototype.setUserid = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string talkId = 2;
 * @return {string}
 */
proto.DataContent.ChatMsgContent.prototype.getTalkid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/** @param {string} value */
proto.DataContent.ChatMsgContent.prototype.setTalkid = function(value) {
  jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string msgContent = 3;
 * @return {string}
 */
proto.DataContent.ChatMsgContent.prototype.getMsgcontent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.DataContent.ChatMsgContent.prototype.setMsgcontent = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string signFlag = 4;
 * @return {string}
 */
proto.DataContent.ChatMsgContent.prototype.getSignflag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/** @param {string} value */
proto.DataContent.ChatMsgContent.prototype.setSignflag = function(value) {
  jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int32 action = 1;
 * @return {number}
 */
proto.DataContent.prototype.getAction = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.DataContent.prototype.setAction = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ChatMsgContent chatMsgContent = 2;
 * @return {?proto.DataContent.ChatMsgContent}
 */
proto.DataContent.prototype.getChatmsgcontent = function() {
  return /** @type{?proto.DataContent.ChatMsgContent} */ (
    jspb.Message.getWrapperField(this, proto.DataContent.ChatMsgContent, 2));
};


/** @param {?proto.DataContent.ChatMsgContent|undefined} value */
proto.DataContent.prototype.setChatmsgcontent = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.DataContent.prototype.clearChatmsgcontent = function() {
  this.setChatmsgcontent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.DataContent.prototype.hasChatmsgcontent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string extend = 3;
 * @return {string}
 */
proto.DataContent.prototype.getExtend = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/** @param {string} value */
proto.DataContent.prototype.setExtend = function(value) {
  jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto);
